import { render, staticRenderFns } from "./device_detail_record_repair_records.vue?vue&type=template&id=56aa8ea1"
import script from "./device_detail_record_repair_records.vue?vue&type=script&lang=js"
export * from "./device_detail_record_repair_records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports